import React from 'react';
import Card from '../components/Card';
import cog from '../assets/cogapp.jpg';
import pod from '../assets/PODCAST.png';
import map from '../assets/map.jpg';
import todo from '../assets/todo.jpg';

import stream from '../assets/stream.jpg';

const Info = () => {
  return (
    <div className=' mx-[24px] md:mx-[90px] lg:mx-[120px]'>
      <h1 className='text-2xl md:text-4xl font-bold mb-[24px]'>WHO WE ARE</h1>
      <div className='flex flex-row overflow-x-scroll'>
        <div className='flex space-x-4'>

          <Card
            header='Location And Branches'
            description='Check out the location of our headquarters at Idimu and other branches closer to you'
            image={map}
            href='/locate'
            btnText='See More'
          />

          <Card
            header='Events'
            description='Stay up to date with our daily, weekly, and monthly events as well as church services'
            image={todo}
            href='/events'
            btnText='See More'
          />
          <Card
            header='Podcast'
            description='Check out our podcast where we discuss various activities in society and how they affect our Christian life'
            image={pod}
            href='/podcast'
            btnText='See More'
          />
          <Card
            header='Books and Devotional App'
            description='Read inspirational and biblical books that will help you grow physically and spiritually via our app'
            image={cog}
            href='/'
            btnText='See More'
          />
          <Card
            header='Stream and Videos'
            description='Watch the live stream and previous videos of all our services in all our worship centers'
            image={stream}
            href='/videos'
            btnText='See More'
          />
        </div>
      </div>
    </div>
  );
};

export default Info;